import type { CrmLeadTaskCounts } from '@/api/types/crm/crmLeadTasks.types'

export const EMPTY_CRM_LEAD_TASK_COUNTS: CrmLeadTaskCounts = {
  today: 0,
  overdue: 0,
}

/** Нормализация `task_counts`; нет поля / null → нули. */
export function normalizeCrmLeadTaskCounts(
  value: unknown,
): CrmLeadTaskCounts {
  if (!value || typeof value !== 'object') {
    return { ...EMPTY_CRM_LEAD_TASK_COUNTS }
  }
  const raw = value as { today?: unknown; overdue?: unknown }
  const today = Number(raw.today)
  const overdue = Number(raw.overdue)
  return {
    today: Number.isFinite(today) && today > 0 ? Math.trunc(today) : 0,
    overdue: Number.isFinite(overdue) && overdue > 0 ? Math.trunc(overdue) : 0,
  }
}
